export default __webpack_public_path__ + "static/ampm--mobile@1x-b917f25bb4e9cf77e8924de98fc30cb3.webp";